<template>
    <div>
            <div class="page-nav">
                <div class="nav-div">
                    <a href="javascript:;" class="left logo">
                        <img src="/images/platform/canggang_zhiyun/member-logo.png" style="margin-top:18px" />
                    </a>
                    <div class="right nav-cont">
                        <a class="link" href="/">首页</a>
                        <a class="link" href="/sourceOfGoods.html">货源信息</a>
                        <a class="link" href="/sourceOfVehicleSource.html">车源广场</a>
                        <a class="link" href="/toNewsList.html">新闻公告</a>
                        <a href="javascript:;" class="link link-member" @click="$router.push({name: 'myFortune'})">
                            <img :src="headUrl ? headUrl : '/images/portrait.png'" class="avatar-img" />
                        </a>
                        <div class="clear"></div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
    </div>
  </template>
  <script>
  import { loginService } from '@/services/login';
  export default {
    data(){
      let tokenId = localStorage.getItem('tokenId');
      return {
        headUrl:'',
        isOnline: false,
        tokenId
        
      }
    },
    mounted(){
      this.headUrl = localStorage.getItem("headUrl")
    },
    created(){
      if(location.origin.indexOf('172') !== -1 || location.origin.indexOf('pre') !== -1){
        this.isOnline = false;
      }else {
        this.isOnline = true;
      }
    },
    methods: {
      async gotoJth(){
        let tempRes = await loginService.getTempToken({
          sessionId: this.tokenId
        })
        if(this.isOnline){
          window.open('https://scm.zczy56.com/group/#/emptyPage?zhongmian=true&token=' + (tempRes.data || this.tokenId))
        }else {
          window.open('http://supply-chain-group.zczy.com/#/emptyPage?zhongmian=true&token=' + (tempRes.data || this.tokenId))
        }
      }
    }
  
  }
  </script>
  <style lang="stylus" scoped>
  .page-nav
    width: 100%
    height: 64px
    line-height: 63px
    background: #FFF
    border-bottom: 1px solid #EFF0F3
    box-shadow: 0px 1px 4px 0px #E1E6EB
    .nav-div
      width: 1200px
      margin: auto
      .logo
        overflow hidden
        height 64px
      .nav-cont
        .link
          padding 0 20px
          float left
        .link-member
          padding-right 0
          .avatar-img
            float left
            margin 20px 10px 0 0
            width 24px
            height 24px
            border-radius 12px
  </style>